export const ConflictsToastType = {
  ERROR: 0,
  WARNING: 1,
};